<div>
</div>
<div class="navbar-glass fixed top-0 left-0 right-0 w-full z-50">
  <div class="navbar-container">
    <!-- Logo en el borde izquierdo -->
    <a class="logo-container" routerLink="/home">
      <img class="logo" src="../../../assets/images/mav_logo.png" alt="Logo">
    </a>

    <!-- Navbar con enlaces directos centrados -->
    <nav class="navbar-center">
      <a routerLink="/home" routerLinkActive="active-link" class="nav-link">
        <i class="fas fa-home"></i>
        <span>Home</span>
      </a>
      <a routerLink="/orderform" routerLinkActive="active-link" class="nav-link nav-link-primary">
        <i class="fas fa-plus"></i>
        <span>Pedido</span>
      </a>
      <a routerLink="/history" routerLinkActive="active-link" class="nav-link">
        <i class="fas fa-list-alt"></i>
        <span>Órdenes</span>
      </a>

      <!-- Dropdown de Gestión -->
      <div class="gestion-dropdown-container">
        <button (click)="toggleGestionMenu()" class="nav-link gestion-button" [class.active-link]="isGestionMenuOpen">
          <i class="fas fa-cogs"></i>
          <span>Gestión</span>
          <i class="fas fa-chevron-down gestion-chevron" [class.rotate-180]="isGestionMenuOpen"></i>
        </button>

        <!-- Menú desplegable de Gestión -->
        <div *ngIf="isGestionMenuOpen" class="gestion-dropdown-menu">
          <a (click)="navigateToGestion('/admin/package-management', 'empaquetado')" class="dropdown-item">
            <i class="fas fa-box"></i>
            <span>Paquetes</span>
          </a>
          <a (click)="navigateToGestion('/admin/package-management', 'cargado')" class="dropdown-item">
            <i class="fas fa-truck-loading"></i>
            <span>Cargar</span>
          </a>
          <a (click)="navigateToGestion('/admin/package-management', 'enviado')" class="dropdown-item">
            <i class="fas fa-tools"></i>
            <span>Enviar a Taller</span>
          </a>
          <a (click)="navigateToGestion('/admin/packages-management', null)" class="dropdown-item">
            <i class="fas fa-edit"></i>
            <span>Gestionar Existentes</span>
          </a>
          <a (click)="navigateToGestion('/admin/package-management', 'historial')" class="dropdown-item">
            <i class="fas fa-history"></i>
            <span>Historial</span>
          </a>
          <a (click)="navigateToGestion('/admin/exported-folders', null)" class="dropdown-item">
            <i class="fas fa-folder-open"></i>
            <span>Carpetas Exportadas</span>
          </a>
          <a (click)="navigateToGestion('/admin/workshops', null)" class="dropdown-item">
            <i class="fas fa-tools"></i>
            <span>Talleres Registrados</span>
          </a>
          <a *ngIf="canAccessKpi" (click)="navigateToGestion('/admin/packaging-kpi', null)" class="dropdown-item">
            <i class="fas fa-chart-line"></i>
            <span>KPIs</span>
          </a>
        </div>
      </div>
    </nav>

    <!-- Menú desplegable a la derecha -->
    <div class="menu-container">
      <button (click)="toggleMenu()" class="menu-button">
        <span>Menú</span>
        <i class="fas fa-chevron-down" [class.rotate-180]="isMenuOpen"></i>
      </button>

      <!-- Menú desplegable -->
      <div *ngIf="isMenuOpen" class="dropdown-menu">
        <a routerLink="/profile" (click)="toggleMenu()" class="dropdown-item">
          <i class="fas fa-user"></i>
          <span>Mi perfil</span>
        </a>
        <a routerLink="/documentation" (click)="toggleMenu()" class="dropdown-item">
          <i class="fas fa-book"></i>
          <span>Documentación</span>
        </a>
        <button (click)="logOut()" class="dropdown-item dropdown-item-logout">
          <i class="fas fa-sign-out-alt"></i>
          <span>Cerrar sesión</span>
        </button>
      </div>
    </div>
  </div>
</div>